export function displayName(input) {
  if (!input) {
    return "";
  }

  return input.toLowerCase().split(" ").map(item => `${item[0].toUpperCase()}${item.substr(1)}`).join(" ");
}